import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.labelPrint || initialState;

export const selectLabelPrint = createSelector([selectSlice], state => state);
